import { Card, Grid } from "@mui/material";
import React from "react";
import CardBody from "../../../../components/Card/CardBody";
import FormTextTC from "../../../../components/Forms/FormTextTC";
import MenuSyncSettings from "../MenuSyncSettings";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";
import FormSwitchTC from "../../../../components/Forms/FormSwitchTC";

function Mrwinston() {
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <Grid container spacing={1} style={{ maxWidth: 1400 }}>
            <Grid item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Mr Winston"} tKey={"vestigingen.form.mrwinston.headers.mrwinston"} />
              </h3>
            </Grid>
            <FormTextTC name={"mrwAppID"} tDefault={"APP ID"} tKey={"vestigingen.form.mrwinston.label.mrwAppID"} />
            <FormTextTC name={"mrwApiKey"} tDefault={"APP KEY"} tKey={"vestigingen.form.mrwinston.label.mrwApiKey"} />
            <FormTextTC
              name={"mrwApiUrl"}
              tDefault={"Service URL"}
              tKey={"vestigingen.form.mrwinston.label.mrwApiUrl"}
            />
            <FormTextTC
              name={"mrwServiceBill"}
              tDefault={"Rekening"}
              tKey={"vestigingen.form.mrwinston.label.mrwServiceBill"}
            />
            <FormTextTC
              name={"mrwServiceTable"}
              tDefault={"Bediening (service)"}
              tKey={"vestigingen.form.mrwinston.label.mrwServiceTable"}
            />
            <FormSwitchTC
              name={"mplusOCnt"}
              tDefault={"Send OCnt"}
              tKey={"vestigingen.form.mplusapi.label.mplusOCnt"}
            />
            <MenuSyncSettings />
          </Grid>
        </CardBody>
      </Card>
    </div>
  );
}

export default Mrwinston;
